module.exports = __webpack_public_path__ + "assets/img/saveCost.47324b4f.jpg";